"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _core = require("@linaria/core");
var _commonStyles = require("../styles/commonStyles");
var _propTypes = _interopRequireDefault(require("prop-types"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
const recommendationsSkeletonStyles = "r16iespz";
const PlanTypeSkeleton = _ref => {
  let {
    showNav = false,
    showSearch = false,
    showHeadline = false,
    cardCount = 3
  } = _ref;
  const skeletonCards = [...new Array(cardCount)].map((_, idx) => {
    return /*#__PURE__*/_react.default.createElement("div", {
      className: 'skeletonCard',
      key: `skeleton-card-${idx}`,
      "data-testid": "skeleton-plan-type"
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "innerCard"
    }, /*#__PURE__*/_react.default.createElement("span", {
      className: (0, _core.cx)(_commonStyles.skeletonTextRow, _commonStyles.skeletonAnimatedBg, 'skeletonCardImage', 'd-block')
    }), /*#__PURE__*/_react.default.createElement("span", {
      className: (0, _core.cx)(_commonStyles.skeletonTextRow, _commonStyles.skeletonAnimatedBg, 'skeletonCardText1', 'd-block')
    }), /*#__PURE__*/_react.default.createElement("span", {
      className: (0, _core.cx)(_commonStyles.skeletonTextRow, _commonStyles.skeletonAnimatedBg, 'skeletonCardText2', 'd-block')
    }), /*#__PURE__*/_react.default.createElement("span", {
      className: (0, _core.cx)(_commonStyles.skeletonTextRow, _commonStyles.skeletonAnimatedBg, 'skeletonCardText3', 'd-block')
    })));
  });
  return /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _core.cx)(recommendationsSkeletonStyles, 'skeletonContainer')
  }, showNav && /*#__PURE__*/_react.default.createElement("span", {
    className: (0, _core.cx)(_commonStyles.skeletonTextRow, _commonStyles.skeletonAnimatedBg, 'skeletonNav', 'd-block')
  }), !showNav && showHeadline && /*#__PURE__*/_react.default.createElement("span", {
    className: (0, _core.cx)('skeletonNavSpacer', 'd-block')
  }), showSearch && /*#__PURE__*/_react.default.createElement("span", {
    className: (0, _core.cx)(_commonStyles.skeletonTextRow, _commonStyles.skeletonAnimatedBg, 'skeletonSearch', 'd-block')
  }), showHeadline && /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("span", {
    className: (0, _core.cx)(_commonStyles.skeletonTextRow, _commonStyles.skeletonAnimatedBg, 'skeletonFilterNav', 'd-block')
  }), /*#__PURE__*/_react.default.createElement("span", {
    className: (0, _core.cx)(_commonStyles.skeletonTextRow, _commonStyles.skeletonAnimatedBg, 'skeletonHeadline', 'd-block')
  }), /*#__PURE__*/_react.default.createElement("span", {
    className: (0, _core.cx)(_commonStyles.skeletonTextRow, _commonStyles.skeletonAnimatedBg, 'skeletonDescription', 'd-block')
  })), /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _core.cx)('skeletonCardContainer', 'fs-unmask')
  }, skeletonCards));
};
PlanTypeSkeleton.propTypes = {
  showNav: _propTypes.default.bool,
  showSearch: _propTypes.default.bool,
  showHeadline: _propTypes.default.bool,
  cardCount: _propTypes.default.number
};

// TODO: revert as part of
// https://godaddy-corp.atlassian.net/browse/NXT-2667
// after https://godaddy-corp.atlassian.net/browse/NXT-2611 is
// available in prod
PlanTypeSkeleton.propTypes = {
  spinner: _propTypes.default.bool
};
PlanTypeSkeleton.defaultProps = {
  spinner: true
};
var _default = PlanTypeSkeleton;
exports.default = _default;